<template lang="pug">
    v-flex(grow-shrink-0)
        v-layout(row align-center)
            slot(name="prepend")
            .headline.pageCaption--text {{title}}
            v-icon(size="30" color="primary").pl-2 {{icon}}
            slot(name="append")
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: String,
    icon: String
  }
};
</script>

<style scoped></style>
